var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['the-header', _vm.bk && 'bk-img']},[(_vm.$route.path === '/home')?_c('the-header-tab'):_vm._e(),_c('span',{staticClass:"title",on:{"click":_vm.handleClickgoMode}},[_vm._v("道路安全监测管理系统")]),_c('the-header-dropdown')],1)}
var staticRenderFns = []

export { render, staticRenderFns }